import styled from 'styled-components';
import React from 'react';
import { PartnerScheduleTime } from '../../apis/models/partner-schedules/res/PartnerScheduleTime';
import colors from '../../constants/colors.constants';
import strings from '../../constants/strings.constants';

export interface ReservationTimeSelectRadioGroupProps {
  timeBlocks?: PartnerScheduleTime[];
  loading?: boolean;
  value?: string;
  onTimeSelect?: (timeText: string) => void;
}
function ReservationTimeSelectRadioGroup(
  props: ReservationTimeSelectRadioGroupProps,
) {
  const { onTimeSelect, value, timeBlocks = [], loading = false } = props;
  return (
    <div className="mt-[24px] flex flex-col gap-3">
      <div className="grid grid-cols-4 gap-2">
        {timeBlocks.map((timeBlock) => {
          const { timeText, available } = timeBlock;
          const selected = value === timeText;
          return (
            <TimeBlockButton
              $selected={selected}
              key={timeText}
              disabled={loading || !available}
              onClick={() => {
                if (onTimeSelect) onTimeSelect(timeText);
              }}
            >
              <div className="flex flex-col gap-1">
                <div
                  style={{
                    fontSize: 14,
                    textDecoration: !available ? 'line-through' : 'none',
                    fontWeight: 600,
                  }}
                >
                  {timeText}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    textDecoration: !available ? 'line-through' : 'none',
                    fontWeight: 400,
                    color: selected
                      ? 'white'
                      : available
                        ? colors.slate500
                        : colors.slate400,
                  }}
                >
                  {available
                    ? strings.reservationAvailable
                    : strings.reservationUnavailable}
                </div>
              </div>
            </TimeBlockButton>
          );
        })}
      </div>
    </div>
  );
}

export default ReservationTimeSelectRadioGroup;

const TimeBlockButton = styled.button<{
  $selected: boolean;
}>`
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
  flex: 1 0 0;
  border-color: ${(props) => {
    if (props.$selected) return '#CBD5E1';
    return '#CBD5E1';
  }};
  border-width: 1px;
  border-style: solid;
  background: ${(props) => {
    if (props.$selected) return colors.slate800;
    return '#FFFFFF';
  }};
  color: ${(props) => {
    if (props.$selected) return 'white';
    return '#4D5B70';
  }};
  font-size: 15px;
  font-weight: 500;
  font-family: Pretendard;

  &:disabled {
    color: ${(props) => '#97A4B6'};
    background: #f1f5f9;
  }

  transition: 0.2s all;
`;
